import IDMGlobals from './../../IDMGlobals';
//
export default class APIRegistrationConfirmation {
  constructor(API) {
    this.api = API;
  }
  async reset(email) {
    const req = await this.api.newBaseRequest('DELETE', true /*allows role impersonation*/);
    req.path = IDMGlobals.APIPath_RegistrationConfirmation;
    //req.appendQueryParam(IDMGlobals.URLQueryParam_RegConfirmationResetEmail, email);
    req.body = {username: email};
    return await req.exec();
  }
  async confirm(regToken, regCode, email) {
    const req = await this.api.newBaseRequest('GET', true /*allows role impersonation*/);
    req.path = IDMGlobals.APIPath_RegistrationConfirmation;
    req.appendQueryParam(IDMGlobals.URLQueryParam_RegConfirmationToken, regToken);
    req.appendQueryParam(IDMGlobals.URLQueryParam_RegConfirmationCode, regCode);
    req.appendQueryParam(IDMGlobals.URLQueryParam_Email, email);
    return await req.exec();
  }
  async confirmAsAdmin(email) {
    const req = await this.api.newBaseRequest('POST');
    req.path = IDMGlobals.APIPath_RegistrationConfirmation;
    req.body = {username: email};
    return await req.exec();
  }
}
